export default "__VITE_ASSET__dcc7b70d__"